import { FC } from 'react';
import styled from '@emotion/styled';
import { ResultProps } from './ResultList';
import { Regular } from '@zazume/zzm-base';
import { css } from '@emotion/react';

const Container = styled.div(({ theme }) => css`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  padding: 0;
  user-select: none;
  padding: ${theme.spacing.sm} 0;
`);

export const AgencyResult: FC<ResultProps> = ({ result, onSelect }) => {
  const handleSelect = () => onSelect(result);

  return (
    <Container onClick={handleSelect}>
      <Regular>{result.publicName}</Regular>
    </Container>
  );
};
